import styles from '@features/categories/components/CategoriesFilterRange/CategoriesFilterRange.styles';

type PropsType = {
  props: Record<string, unknown>;
  isDragged: boolean;
};

const CategoriesFilterRangeThumb = ({ props, isDragged }: PropsType) => {
  const { style, ...restProps } = props;
  const { height: _height, width: _width, ...positionStyle } = (style || {}) as React.CSSProperties;

  return <div {...restProps} key={restProps.key as React.Key} style={positionStyle} sx={styles.thumb(isDragged)} />;
};

export default CategoriesFilterRangeThumb;
